import dayjs from 'dayjs';

// APP CONSTANT
export const APP_NAME = 'ASPYRE2';

// UI constant
export const HEADER_HIGHT = 82;

const LAYOUT_CONST = {
    VERTICAL_LAYOUT: 'vertical',
    HORIZONTAL_LAYOUT: 'horizontal',
    DEFAULT_DRAWER: 'default',
    MINI_DRAWER: 'mini-drawer'
};

export const TABLE_HEIGHT = {
    SMALL: 500,
    MEDIUM: 'calc(100vh - 560px)',
    LARGE: 'calc(100vh - 320px)'
};

export default LAYOUT_CONST;

export const gridSpacing = 3;
export const drawerWidth = 320;
export const appDrawerWidth = 320;

export const AUTO_CUTOFF_DAYS = [
    { key: 1, value: 1 },
    { key: 2, value: 2 },
    { key: 3, value: 3 },
    { key: 4, value: 4 },
    { key: 5, value: 5 },
    { key: 6, value: 6 },
    { key: 7, value: 7 },
    { key: 10, value: 10 },
    { key: 14, value: 14 }
];

export const PATIENT_NAME_ORDERING = [
    { value: 1, label: 'First Middle Last', order: ['first_name', 'middle_name', 'last_name'] },
    { value: 2, label: 'Last, First Middle', order: ['last_name', 'first_name', 'middle_name'] }
];

export const NOTIFICATION_DURATION = 2000;

// Common
export const EVENT_TYPES = [
    {
        id: 1,
        name: 'Evaluation',
        code: 'evaluation',
        group: 'therapy'
    },
    {
        id: 2,
        name: 'Treatment',
        code: 'treatment',
        group: 'therapy'
    },
    {
        id: 3,
        name: 'EIDT',
        code: 'eidt',
        group: 'school'
    },
    {
        id: 4,
        name: 'ADDT',
        code: 'addt',
        group: 'school'
    },
    {
        id: 5,
        name: 'ITP',
        code: 'itp',
        group: 'school'
    }
];

export const getEventTypeById = (id) => EVENT_TYPES.find((type) => type.id === id).name;

export const getEventTypeByCode = (code) => EVENT_TYPES.find((type) => type.code === code).name;

export const THERAPY_EVENTS = {
    EVALUATION: 1,
    TREATMENT: 2
};

export const VISIT_TYPES = {
    EVALUATION: 1,
    TREATMENT: 0,
    ACTIVITY: 3,
    PSYCHOLOGICAL_TESTING: 8,
    NURSING: 10,
    PERSONAL_CARE: 4,
    PERSONAL_CARE_ON_BUS: 5,
    TRANSPORTATION: 6,
    TIME_ENTRY: 7,
    COUNSELING: 9,
    PSYCHOLOGICAL_SERVICES: 11
};

export const EVENT_IDS = {
    EVALUATION: 1,
    TREATMENT: 1,
    ACTIVITY: 3,
    PSYCHOLOGICAL_TESTING: 8,
    NURSING: 10,
    PERSONAL_CARE: 4,
    PERSONAL_CARE_ON_BUS: 5,
    TRANSPORTATION: 6,
    TIME_ENTRY: 7,
    COUNSELING: 9,
    PSYCHOLOGICAL_SERVICES: 11
};

// Therapy
export const THERAPIES = {
    pt: 1,
    st: 2,
    ot: 3,
    dt: 4
};

export const NURSING_LICENCE = ['RN', 'APRN', 'Delegated', 'LVN', 'LPN'];

export const SERVICES = [
    {
        id: 1,
        name: 'Physical Therapy',
        shortName: 'PT'
    },
    {
        id: 2,
        name: 'Speech Therapy',
        shortName: 'ST'
    },
    {
        id: 3,
        name: 'Occupational Therapy',
        shortName: 'OT'
    },
    {
        id: 4,
        name: 'Developmental Therapy',
        shortName: 'DT'
    }
];

export const SESSION_SERVICES = [
    {
        service_name: 'Speech Therapy',
        service_code: 'ST',
        service_id: 2
    },
    {
        service_name: 'Occupational Therapy',
        service_code: 'OT',
        service_id: 3
    },
    {
        service_name: 'Physical Therapy',
        service_code: 'PT',
        service_id: 1
    },
    {
        service_name: 'Other',
        service_code: 'OTHERS',
        service_id: null
    }
];

export const SESSION_PDC_SERVICES = {
    service_name: 'EIDT',
    service_code: 'PDC',
    id: 5
};

export const SESSION_EIDT_SERVICES = {
    service_name: 'EIDT',
    service_code: 'EIDT',
    id: 5
};

export const SESSION_ADDT_SERVICES = {
    service_name: 'ADDT',
    service_code: 'ADDT',
    id: 6
};

export const getServiceNameById = (id) => SERVICES.find((service) => service.id === id)?.name;

export const getServiceIdByShortName = (name) => SERVICES?.find((service) => service?.shortName?.toUpperCase() === name?.toUpperCase())?.id;

export const THERAPY_MIN_TIME = dayjs().set('hour', 6).set('minute', 0).set('second', 0);
export const THERAPY_MAX_TIME = dayjs().set('hour', 22).set('minute', 59).set('second', 59);

// Others
export const SERVICE_PDC = 5;
export const SERVICE_EIDT = 5;
export const SERVICE_ADDT = 6;
export const SERVICE_IEP = 7;
export const SERVICE_PDC_ANCILLARY = 8;
export const SERVICE_EIDT_ANCILLARY = 8;
export const SERVICE_ADDT_ANCILLARY = 9;
export const SERVICE_PERSONAL_CARE = 10;
export const SERVICE_PERSONAL_CARE_ON_BUS = 11;
export const SERVICE_TRANSPORTATION = 12;
export const SERVICE_PSYCHOLOGICAL_TESTING = 13;
export const SERVICE_NURSING = 15;
export const SERVICE_COUNSELING = 14;
export const SERVICE_PSYCHOLOGICAL_SERVICE = 16;
export const SERVICE_DAY_TREATMENT_TRANSPORTATION = 17;
export const STATUSID = 1;

export const ACTIVITY_EIDT_STAFFING_CONF = 2;

export const ACTIVITY_ADMINISTRATIVE_BILLING = 24;

export const ACTIVITY_ANNUAL_REVIEW = 100;

export const MEDICAL_HEALTH_SERVICE_CONFIG = {
    counseling: {
        service_id: SERVICE_COUNSELING,
        labelName: 'Counseling',
        pathName: 'counseling',
        permissionBaseKey: 'counseling'
    },
    psychologicalservice: {
        service_id: SERVICE_PSYCHOLOGICAL_SERVICE,
        labelName: 'Psychological Service',
        pathName: 'psychologicalservice',
        permissionBaseKey: 'psychological_service'
    }
};

export const PERSONAL_CARE_STATUS = {
    ONGOING: 8,
    COMPLETED: 7
};

export const THERAPY_STATUS = {
    SCHEDULED: 9,
    ONGOING: 8,
    COMPLETED: 7
};

export const THERAPY_STATUS_LIST = [
    { id: 9, name: 'Scheduled' },
    { id: 8, name: 'Ongoing' },
    { id: 7, name: 'Completed' }
];

export const STUDENT_STATUS_LIST = {
    PRESENT: 'PRESENT',
    ABSENT: 'ABSENT',
    COMPLETED: 'COMPLETED',
    PICKED_UP: 'PICKED UP'
};

export const STUDENT_STATUS_ONGOING = [
    'EIDT ONGOING',
    'ADDT ONGOING',
    'ST ONGOING',
    'PT ONGOING',
    'OT ONGOING',
    'OTHERS ONGOING',
    'EIDT CHECKED IN',
    'ADDT CHECKED IN'
];

// PDC
export const CLASS = {
    pdc: 5,
    eidt: 5,
    addt: 6
};

export const CLASS_CODE = {
    pdc: 'PDC',
    eidt: 'EIDT',
    addt: 'ADDT'
};

export const SERVICE_CONFIG = {
    pdc: {
        id: 5,
        name: 'pdc',
        service_code: 'PDC',
        permission: 'pdc'
    },
    eidt: {
        id: 5,
        name: 'eidt',
        service_code: 'EIDT',
        permission: 'eidt'
    },
    addt: {
        id: 6,
        name: 'addt',
        service_code: 'ADDT',
        permission: 'addt'
    }
};

export const SCHEDULED_COLORS = {
    5: '#ec9c3d',
    6: '#9E1E9E'
};

export const BUSINESS_TYPE_LOCATION_ID = 4;
export const PDC_TYPE_LOCATION_ID = 5;
export const EIDT_TYPE_LOCATION_ID = 5;
export const SCHOOL_TYPE_LOCATION_ID = 6;
export const ADDT_TYPE_LOCATION_ID = 7;
export const DDTCS_TYPE_LOCATION_ID = 1;
export const ECI_TYPE_LOCATION_ID = 3;
export const NURSHM_TYPE_LOCATION_ID = 2;

export const LOCATION_TYPE_MAP = {
    pdc: PDC_TYPE_LOCATION_ID,
    eidt: EIDT_TYPE_LOCATION_ID,
    addt: ADDT_TYPE_LOCATION_ID,
    school: SCHOOL_TYPE_LOCATION_ID,
    business: BUSINESS_TYPE_LOCATION_ID
};

export const BUSINESS_AND_OUTPATIENT_LOCATION_TYPES = [
    BUSINESS_TYPE_LOCATION_ID,
    DDTCS_TYPE_LOCATION_ID,
    ECI_TYPE_LOCATION_ID,
    NURSHM_TYPE_LOCATION_ID
];

export const INVENTORY_STATUS = {
    AVAILABLE: { id: 15, color: '#66bb6a', status: 'AVAILABLE' },
    UNAVAILABLE: { id: 16, color: '#9e9e9e', status: 'UNAVAILABLE' },
    'IN USE': { id: 17, color: '#ffa726', status: 'IN USE' }
};

export const EMPLOYEE_LICENSE_EXPIRATION_TIMELINE = 30;
export const NOTIFICATION_PANEL_DIMENSIONS = [450, 550]; // [w, h]

export const LIST_LIMIT = 15;

export const LARGE_LIST_LIMIT = 50;

// Status constants
export const SESSIONS_STATUS = {
    ABSENT: 1,
    CLASSROOM_ONGOING: 2,
    ST_ONGOING: 3,
    PT_ONGOING: 4,
    OT_ONGOING: 5,
    OTHERS_ONGOING: 6,
    COMPLETED: 7,
    ONGOING: 8,
    SCHEDULED: 9,
    IN_PROGRESS: 10,
    NOSHOW: 11,
    SESSION_START: 12,
    SESSION_END: 13,
    PRESENT: 14
};

export const ECDS_SIGN_PENDING_DUMMY = 0;

export const STATUS = [
    { id: 1, name: 'Absent' },
    { id: 14, name: 'Present' },
    { id: 41, name: 'Refused' },
    { id: 42, name: 'Unavailable' }
];

export const ASSESSMENT_TYPE = [
    { id: 1, name: 'Initial' },
    { id: 2, name: 'Re-evaluation' }
];

export const PSYCHOL_ASSESS_ACTIVITY = [
    { id: 1, name: 'Testing' },
    { id: 2, name: 'Interpretation' },
    { id: 3, name: 'Report Writing' }
];

export const ACTIVE_TYPE = [
    { id: 1, name: 'Active' },
    { id: 0, name: 'Inactive' }
];

export const ACTIVE_STATUS = 1;

export const PAYER_CATEGORY_ID = 1;

export const PAYER_CATEGORY_VOUCHER = { id: 4, name: 'Voucher', key: 'voucher' };

export const MISSED_SESSION_REPORT = [
    { id: 1, name: 'Patient Absent' },
    { id: 2, name: 'Patient Unavailable' },
    { id: 3, name: 'Therapist Unavailable' },
    { id: 4, name: 'Pending Authorization' }
];

export const CLIENT_SWITCH_EXCLUDE = ['id', 'sid', 'tid', 'stid'];
export const EMAIL_CLIENT_TYPE_LIST = { id: 1, name: 'client' };
export const EMAIL_INDIVIDUAL_TYPE_LIST = { id: 3, name: 'individual' };
export const EMAIL_INTERNAL_TYPE_LIST = { id: 2, name: 'internal' };

export const MAIL_SEEN_STATUS = { id: 19, name: 'SEEN' };
export const MAIL_UNSEEN_STATUS = { id: 18, name: 'UNSEEN' };

export const GLOBAL_DATE_FORMAT = 'MM/DD/YYYY';
export const GLOBAL_DATE_FORMAT_DFNS = 'MM/dd/yyyy';

export const GLOBAL_DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';

export const GLOBAL_TIME_FORMAT = 'hh:mm A';

export const PAYLOAD_DATE_FORMAT = 'YYYY-MM-DD';
export const PAYLOAD_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const PAYLOAD_DATE_TIME_SECOND_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const BATCH_STATUS_CREATED = 21;

export const BATCH_STATUS_PAID = 32;

export const BATCH_STATUS_REJECTED = 23;

export const BATCH_STATUS_REJECTED_DRAFT = 46;

export const BATCH_STATUS = {
    21: { id: 21, color: '#4caf50', status: 'CREATED' },
    22: { id: 22, color: '#2196f3', status: 'SUBMITTED' },
    23: { id: 23, color: '#ff9800', status: 'REJECTED' },
    24: { id: 24, color: '#ffeb3b', status: 'ACKNOWLEDGED' },
    32: { id: 32, color: '#4caf50', status: 'PAID' },
    26: { id: 26, color: '#424242', status: 'DRAFT' },
    46: { id: 46, color: '#ff9800', status: 'REJECTED' },
    47: { id: 47, color: '#424242', status: 'DRAFT' }
};

export const PATIENT_INVOICE_STATUS = {
    10: { id: 10, color: '#2196f3', status: 'IN PROGRESS' },
    32: { id: 32, color: '#4caf50', status: 'PAID' },
    33: { id: 33, color: '#ffeb3b', status: 'READY TO INVOICE' },
    34: { id: 34, color: '#ffeb3b', status: 'READY TO CLAIM' },
    35: { id: 35, color: '#ffeb3b', status: 'BATCHED' },
    36: { id: 36, color: '#ffeb3b', status: 'SENT TO CLEARING HOUSE' },
    37: { id: 37, color: '#ffeb3b', status: 'INVOICED' },
    43: { id: 43, color: '#4caf50', status: 'PAID(INVOICE)' },
    23: { id: 23, color: '#f59b3e', status: 'REJECTED' },
    24: { id: 24, color: '#ff9818', status: 'ACKNOWLEDGED' },
    44: { id: 44, color: '#ffeb3b', status: 'NO BILL' },
    50: { id: 50, color: '#6160688c', status: 'NO BILLABLE' }
};

export const CLAIM_TYPE = {
    TREATMENT: 1,
    EVALUATION: 1,
    PERSONAL_CARE: 4,
    TRANSOPRT: 5,
    TRANSPORT_LOG: 6,
    PSYCHOLOGICAL_TESTING: 8,
    NURSING: 10,
    ACTIVITY_LOG: 3,
    COUNSELING: 9,
    PSYCHOLOGICAL_SERVICE: 11
};

export const PARTIAL_CLAIM_EDIT_COUNT = 10;

export const ACTIVITY_LOGS = {
    CATEGORY_EIDT: 1,
    CATEGORY_SUPERVISOR: 2,
    CATEGORY_CONFERENCE: 3,
    CONFERENCE_SERVICES: [1, 2, 3],
    EIDT_PAYABLE_MIN: 15
};

export const DOCUMENT_TYPES = {
    DMS_640: 6,
    IEP: 9,
    PLAN_504: 35
};

export const PRESCRIPTION_STATUS = {
    DRAFT: [25, 26],
    IN_PROGRESS: [27, 28],
    COMPLETED: [29],
    NEW: [27],
    CANCELLED: [30]
};

export const PHYSICIAN_ROLE_ID = 20;

export const LIMIT_SEARCH = 3;

export const TO_BE_SIGNED_PRESCRIPTION_STATUS_ID = 27;
export const SIGNED_PRESCRIPTION_STATUS_ID = 29;

export const CARE_CORDINATOR_ROLE_ID = 4;

export const THERAPIST_ROLE_ID = 3;
export const ASSISTANT_THERAPIST_ROLE_ID = 2;

export const ROLE_NAME = {
    THERAPIST: 'Therapist',
    ASSISTANT_THERAPIST: 'Assistant Therapist',
    PERSONAL_CARE_PROVIDER: 'Personal Care Provider',
    PERSONAL_CARE_AIDE: 'Personal Care Aide'
};

export const LOCATION_INVOICE_STATUS = {
    FULLY_PAID: 39
};

export const NOTIFICATION = {
    UNSIGNED_COUNTS_EVAL: 3,
    UNSIGNED_COUNTS_EVAL_SUPERVISOR: 13,
    UNSIGNED_COUNTS_TREATMENT: 8,
    UNSIGNED_COUNTS_TREATMENT_SUPERVISOR: 14,
    UNSIGNED_COUNTS_ITP: 9,
    UNSIGNED_COUNTS_ACTIVITY: 17
};

export const NOTIFICATION_LABEL = {
    UNSIGNED_COUNTS_EVAL: 'NOTIFICATION_UNSIGNED_COUNTS_EVAL',
    UNSIGNED_COUNTS_EVAL_SUPERVISOR: 'NOTIFICATION_UNSIGNED_COUNTS_EVAL_SUPERVISOR',
    UNSIGNED_COUNTS_TREATMENT: 'NOTIFICATION_UNSIGNED_COUNTS_TREATMENT',
    UNSIGNED_COUNTS_TREATMENT_SUPERVISOR: 'NOTIFICATION_UNSIGNED_COUNTS_TREATMENT_SUPERVISOR',
    UNSIGNED_COUNTS_ITP: 'NOTIFICATION_UNSIGNED_COUNTS_ITP',
    UNSIGNED_COUNTS_ACTIVITY: 'NOTIFICATION_UNSIGNED_COUNTS_ACTIVITY',
    UNSIGNED_COUNTS_SESSION: 'NOTIFICATION_UNSIGNED_COUNTS_SESSION'
};

export const SCHOOL_SERVICES = [SERVICE_EIDT, SERVICE_ADDT, SERVICE_IEP, SERVICE_EIDT_ANCILLARY, SERVICE_ADDT_ANCILLARY];

export const ENV = {
    API_ENCRYPTION_KEY: import.meta.env.VITE_ENCRIPTION_KEY,
    API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT,
    API_MAPKEY: import.meta.env.VITE_API_MAPKEY,
    PHYSICIAN_CLIENT: import.meta.env.VITE_PHYSICIAN_CLIENT,
    PHYSICIAN_LOCATION: import.meta.env.VITE_PHYSICIAN_LOCATION,
    CLIENT_CYNERGY_ID: import.meta.env.VITE_CLIENT_CYNERGY_ID,
    ENV_TYPE: import.meta.env.VITE_ENV,
    DEBUG: import.meta.env.VITE_DEBUG,
    GENERATE_SOURCEMAP: import.meta.env.VITE_GENERATE_SOURCEMAP,
    AUTO_LOGOUT_DURATION: import.meta.env.VITE_AUTO_LOGOUT_DURATION
};

// changable constants
export const PHYSICIAN_CLIENT = Number(ENV?.PHYSICIAN_CLIENT);
export const PHYSICIAN_LOCATION = Number(ENV?.PHYSICIAN_LOCATION);
export const CLIENT_CYNERGY_ID = Number(ENV?.CLIENT_CYNERGY_ID);

export const IDLE_TIMEOUT_DURATION = ENV?.AUTO_LOGOUT_DURATION ? Number(ENV?.AUTO_LOGOUT_DURATION) : 120;

export const ITP_TYPES = {
    THERAPY: 'therapy',
    ADDT: 'addt',
    EIDT: 'eidt'
};

export const PENDING_RANGE = [
    { key: 1, label: '0 - 10', min: 0, max: 10 },
    { key: 2, label: '10 - 50', min: 10.01, max: 50 },
    { key: 3, label: '50 - 100', min: 50.01, max: 100 },
    { key: 4, label: '100 - 200', min: 100.01, max: 200 },
    { key: 5, label: '200 - Above', min: 200.01 },
    { key: 6, label: 'Full Payment', isZeroPaid: 1 }
];

export const SERVICE_STATUS = [23, 24, 32, 35, 36, 37, 38, 41, 43, 44];

// export const SERVICE_REPORT_STATUS = [10, 23, 24, 32, 33, 34, 35, 36, 37, 38, 41, 43, 44];
export const SERVICE_REPORT_STATUS = [10, 23, 24, 32, 33, 34, 35, 36, 37, 43, 44];
export const SERVICE_DAY_CENTER_REPORT_STATUS = [10, 23, 24, 32, 33, 34, 35, 36, 37, 43, 44];

export const GETLOCALTIMEZONE = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const PARTIAL_PAYMENT_TYPE = [
    {
        id: 1,
        name: 'Cash'
    },
    {
        id: 2,
        name: 'Card'
    },
    {
        id: 4,
        name: 'Insurance'
    },
    {
        id: 6,
        name: 'Write Off'
    }
];

export const PATIENT_PAYMENT_MODE = [
    {
        id: 9,
        name: 'Deductible'
    },
    {
        id: 10,
        name: 'Co-insurance'
    },
    {
        id: 11,
        name: 'Co-pay'
    },
    {
        id: 12,
        name: 'Self Pay'
    },
    {
        id: 14,
        name: 'Write Off'
    }
];

export const BILLING_TYPE = [
    { key: '1', name: 'Primary', value: 'primary' },
    { key: '2', name: 'Secondary', value: 'secondary' }
];

export const CLASSIFICATION_BLANK = 'Blank';

export const DAYS_LIST = [
    { key: 6, label: 'S', name: 'Sunday' },
    { key: 0, label: 'M', name: 'Monday' },
    { key: 1, label: 'T', name: 'Tuesday' },
    { key: 2, label: 'W', name: 'Wednesday' },
    { key: 3, label: 'T', name: 'Thursday' },
    { key: 4, label: 'F', name: 'Friday' },
    { key: 5, label: 'S', name: 'Saturday' }
];

export const OTHER_SPECIAL_CARE_ID = 6;

export const ACTIVITY_SETUP_LOC_CONFIG = {
    STATUS_PAYROLL_COUNT: 1,
    STATUS_PAYROLL_HOURLY: 2,
    STATUS_INVOICE_COUNT: 3,
    STATUS_INVOICE_HOURLY: 4
};

export const ACTIVITY_SETUP_LOC_CONFIG_NAME = {
    STATUS_PAYROLL_COUNT: 'PAYROLL_COUNT',
    STATUS_PAYROLL_HOURLY: 'PAYROLL_HOURLY',
    STATUS_INVOICE_COUNT: 'INVOICE_COUNT',
    STATUS_INVOICE_HOURLY: 'INVOICE_HOURLY'
};

export const NURSING_ICD_FILTERS = ['F31.9', 'J45.909', 'F90.9', 'F90.1', 'F34.1', 'F84.0', 'F98.8', 'R56.9'];

export const NURSING_DIAGNOSIS_FILTERS = [
    'F79',
    'Q90.9',
    'Z43.1',
    'E10.8',
    'G40.11',
    'G40.909',
    'E11.8',
    'E10.9',
    'C71.9',
    'F84.0',
    'E74.09'
];

export const D1_PROC = 'T1502';

export const NURSING_SETUP_ID = 450;

export const HISTORY_ACTION_COLORS = {
    'add external': '#6A5ACD', // Slate blue → new external entity
    'add student': '#2E8B57', // Sea green → growth, addition
    'early dismiss': '#FF8C00', // Dark orange → caution/attention (not red)
    'session start': '#1E90FF', // Dodger blue → beginning/action
    'session end': '#4B5563', // Cool gray → neutral closure
    signed: '#8B5CF6', // Violet → confirmation/approval
    'switch session': '#0D9488' // Teal → transition/change
};
